export default __webpack_public_path__ + "static/media/480_private01-en-mobile.2224da70.png";